import React from 'react';
import PageMeta from './PageMeta';
import { useTranslation } from '../contexts/LanguageContext';
import './LegalDocument.css';

const SUPPORT_EMAIL = 'support@word-labyrinth.com';
const MailLink = ({ children }) => <a href={`mailto:${SUPPORT_EMAIL}`}>{children}</a>;
const STEPS = ['open', 'settings', 'scroll', 'tapDelete', 'confirm'];
const DELETED_ITEMS = ['profile', 'history', 'rankings', 'achievements', 'purchases', 'push', 'social'];

function DeleteAccount() {
    const { t } = useTranslation();
    const b = { b: <strong /> };

    return (
        <div className="legal-document">
            <PageMeta path="/delete-account" />
            <div className="legal-container">
                <h1>{t('settings.deletePage.heading')}</h1>

                <section>
                    <h2>{t('settings.deletePage.howTitle')}</h2>
                    <p>{t('settings.deletePage.howIntro')}</p>
                    <ol>
                        {STEPS.map(step => (
                            <li key={step}>{t.rich(`settings.deletePage.steps.${step}`, b)}</li>
                        ))}
                    </ol>
                    <p>{t('settings.deletePage.howOutro')}</p>
                </section>

                <section>
                    <h2>{t('settings.deletePage.whatTitle')}</h2>
                    <ul>
                        {DELETED_ITEMS.map(item => (
                            <li key={item}>{t(`settings.deletePage.items.${item}`)}</li>
                        ))}
                    </ul>
                </section>

                <section>
                    <h2>{t('settings.deletePage.emailTitle')}</h2>
                    <p>
                        {t.rich('settings.deletePage.emailText', { mail: <MailLink /> }, { email: SUPPORT_EMAIL })}
                    </p>
                    <p>{t('settings.deletePage.emailDeadline')}</p>
                </section>

                <section>
                    <h2>{t('settings.deletePage.exportTitle')}</h2>
                    <p>{t.rich('settings.deletePage.exportText', b)}</p>
                </section>
            </div>
        </div>
    );
}

export default DeleteAccount;
